export default "__VITE_PUBLIC_ASSET__1858d868__"